module.exports = __webpack_public_path__ + "img/icon_logo.c82389cc.png";